import { Directive, Inject, DOCUMENT, OnDestroy, afterNextRender } from '@angular/core';

@Directive({
  selector: '[scrollProgress]',
  standalone: true,
})
export class ScrollProgressBarDirective implements OnDestroy {
  winScroll: number = 0;
  height: number = 0;
  scrolled: number = 0;
  private scrollListener?: () => void;

  constructor(@Inject(DOCUMENT) private document: Document) {
    // afterNextRender only runs in the browser, never during SSR
    afterNextRender(() => {
      this.scrollListener = () => {
        const progressBarElement = this.document.getElementById(
          'scroll-progress-bar',
        );
        this.winScroll =
          window.scrollY ||
          this.document?.documentElement?.scrollTop ||
          this.document?.body?.scrollTop ||
          0;
        this.height =
          (this.document?.documentElement?.scrollHeight ||
            this.document?.body?.scrollHeight ||
            0) -
          (this.document?.documentElement?.clientHeight ||
            this.document?.body?.clientHeight ||
            0);
        this.scrolled = this.height > 0 ? (this.winScroll / this.height) * 100 : 0;
        if (progressBarElement) {
          progressBarElement.style.width = this.scrolled + '%';
        }
      };
      window.addEventListener('scroll', this.scrollListener, { passive: true });
    });
  }

  ngOnDestroy(): void {
    if (typeof window !== 'undefined' && this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = undefined;
    }
  }
}
